<template>
  <section :class="phoneClass || 'content-container'">
    <transition  name="fade" mode="out-in">
      <router-view ></router-view>
    </transition>
  </section>
</template>

<script>
import {refresh} from "../../../core/winSize";

export default {
    name: 'app-content',
    data () {
        return {
            phoneClass: '',
        }
    },
    created() {
        refresh(this,'phoneClass-content-container');
        window.onresize = function(){
            setTimeout(function(){
                refresh(this,'phoneClass-content-container');
            },10)
        };
    },
}
</script>

<style scoped lang="scss">
  .content-container {
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    flex: 1;
    min-height: 100vh;
    -webkit-flex: 1;
    overflow: auto;
    // min-width: 1080px;
  }
  .phoneClass-content-container {
      min-height: calc(100vh - 60px);
  }
</style>